import type { AnyRouter } from '@tanstack/react-router';
import * as React from 'react';

/** Routers currently mounted, oldest first. Nested or side-by-side providers (tests, portals) stack. */
const mounted: AnyRouter[] = [];

/** Registers `router` as the mounted one in a layout effect, so a `buildHref` in a child's effect sees it. */
function useRegisterMountedRouter(router: AnyRouter): void {
    React.useLayoutEffect(() => {
        mounted.push(router);
        return () => {
            const index = mounted.lastIndexOf(router);
            if (index !== -1) {
                mounted.splice(index, 1);
            }
        };
    }, [router]);
}

/** The most recently mounted router, or `undefined` when none is. */
export function getMountedRouter(): AnyRouter | undefined {
    return mounted[mounted.length - 1];
}

/** Lets a `.ts` file (`routerKit.ts`) register a router through `createElement`. */
export function MountedRouterRegistrar({ router }: { router: AnyRouter }): null {
    useRegisterMountedRouter(router);
    return null;
}
